__turbopack_context__.v({
  "avatar": "ProductBrand-module__Uec-Ja__avatar",
  "brand": "ProductBrand-module__Uec-Ja__brand",
  "copy": "ProductBrand-module__Uec-Ja__copy",
  "hero": "ProductBrand-module__Uec-Ja__hero",
});
